import { PageHero } from '@/components/ui/PageHero'
import { courseThree } from '@/assets/siteMedia'

export const IntegratedHealthHero = () => (
  <PageHero
    image={courseThree}
    imageAlt="Hands grinding fresh herbs in a wooden mortar and pestle"
    highlights={['Integrated Health Report', '80+ page scan report', 'Follow-up Zoom session']}
    title="Consultation + Bio-Scan,"
    accent="brought together."
    description={
      <>
        <p>
          For those wanting a more comprehensive exploration of their health, this service brings
          together an in-depth holistic health consultation with the additional information provided
          by the Bio-Scan.
        </p>
        <p className="text-base text-green-100">
          Rather than considering your symptoms, health history and scan findings separately, we
          look at them together, building a more complete picture of your health.
        </p>
      </>
    }
  />
)
